import { useCallback, useEffect, useRef, useState } from 'react';
import { findDOMNode } from 'react-dom';
import invariant from 'react-utils/invariant';
import { callIfPossible } from '../../utils/functions';
import { ChildrenWrapper } from '../ChildrenWrapper/ChildrenWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export const IntersectionObserver = ({
  renderContent,
  root,
  rootMargin,
  threshold,
  target,
  onIntersectionChange,
  initialIntersecting = false
}) => {
  const {
    IntersectionObserver: IntersectionObserverObject
  } = window;
  const observerRef = useRef(undefined);
  const [childrenWrapperRef, setChildrenWrapperRef] = useState();
  const [isIntersecting, setIsIntersecting] = useState(initialIntersecting);
  /* eslint-disable-next-line react/no-find-dom-node */
  const targetElement = target || findDOMNode(childrenWrapperRef);
  if (process.env.NODE_ENV !== 'production') {
    invariant(!threshold || threshold >= 0 && threshold <= 1, 'IntersectionObserver: `threshold` should be a value between 0 and 1 (received %s)', threshold);
  }
  const stopObserver = useCallback(() => {
    if (observerRef && observerRef.current) {
      observerRef.current.disconnect();
    }
  }, [observerRef]);
  const handleIntersection = useCallback(entries => {
    const {
      isIntersecting: intersecting
    } = entries[0];
    setIsIntersecting(intersecting);
    callIfPossible(onIntersectionChange, {
      entries,
      observer: observerRef.current
    });
  }, [onIntersectionChange]);
  useEffect(() => {
    const startObserver = () => {
      observerRef.current = new IntersectionObserverObject(handleIntersection, {
        root,
        rootMargin: rootMargin,
        threshold
      });
      observerRef.current.observe(targetElement);
    };
    if (IntersectionObserverObject && targetElement) {
      startObserver();
    }
    return stopObserver;
  }, [IntersectionObserverObject, root, rootMargin, stopObserver, threshold, targetElement, handleIntersection]);
  if (!renderContent) {
    return null;
  }
  return (
    /*#__PURE__*/
    // @ts-expect-error - incompatible ref type
    _jsx(ChildrenWrapper, {
      ref: setChildrenWrapperRef,
      children: renderContent(isIntersecting)
    })
  );
};